<template>
  <div class="tab-text  ml-0">
    <vx-card no-shadow class="custom-min-height">
      <!-- Header Section -->
      <div class="text-red-600">
        * ตารางการคำนวณดังกล่าว เป็นการคำนวณคร่าวๆ ยอดเงินต้นและดอกเบี้ยอาจเปลี่ยนแปลงตามวันที่ชำระ
      </div>

      <!-- Loan Input Section -->
      <div class=" flex flex-col gap-4 bg-white p-4 rounded-2xl shadow mb-5">

        <div class="flex gap-4">
          <div class="flex items-center gap-2 w-1/2">
            <label
              class="block text-gray-700 mb-0 w-1/2">วงเงินกู้</label>
            <vs-input type="number" class="input w-1/2" v-model="principle"/>
          </div>
          <div class="flex items-center gap-2 w-1/2">
            <label class="block text-gray-700 mb-1 w-1/2">จำนวนงวด <small
              class="text-grey">(งวดที่เริ่มชำระเงินต้น)</small></label>
            <vs-input type="number" class="input w-1/2" v-model="installmentCount"/>
          </div>
        </div>
        <div class="flex gap-4">
          <div class="flex items-center gap-2 w-1/2">
            <label class="block text-gray-700 mb-0 w-1/2">อัตราดอกเบี้ย %</label>
            <vs-input type="number" class="input w-1/2" v-model="interestRate"/>
          </div>
          <div class="flex items-center gap-2 w-1/2">
            <label class="block text-gray-700 mb-1 w-1/2">รอบชำระเดือนแรก <small class="text-grey">(กำหนดวันที่สิ้นเดือน)</small></label>
            <flat-pickr :config="configPaymentDue" class="input w-1/2" v-model="paymentDue"/>
          </div>
        </div>
        <div class="flex justify-end">
          <vs-button color="primary" @click="calculate">คำนวณ</vs-button>
        </div>
      </div>

      <!-- Summary Box -->
      <div class="flex flex-col gap-4 bg-white p-4 rounded-2xl shadow mb-5">
        <p>รวมยอดชำระต่อเดือน: <span class="font-semibold text-primary">{{ paymentRoundAmount }} บาท</span></p>
        <p>รวมยอดชำระเดือนสุดท้าย: <span class="font-semibold text-primary">{{ paymentRoundAmountLast }} บาท <small
          class="text-grey" v-if="totalRemain > 0">({{ totalRemain }} บาท)</small></span></p>
        <p>วันที่ชำระงวดแรก: <span class="font-semibold text-primary">{{
            firstPaymentDate ? firstPaymentDate : "-"
          }}</span></p>
        <p>วันที่ชำระงวดสุดท้าย: <span class="font-semibold text-primary">{{
            lastPaymentDate ? lastPaymentDate : "-"
          }}</span></p>
      </div>

      <!-- Payment Schedule Table -->
      <div class="overflow-auto">
        <vs-table :data="paymentRounds">
          <template slot="thead">
            <vs-th>งวด</vs-th>
            <vs-th>วันที่ชำระ</vs-th>
            <vs-th>จำนวนวัน</vs-th>
            <vs-th>ยอดผ่อนชำระ</vs-th>
            <vs-th>ชำระดอกเบี้ย</vs-th>
            <vs-th>ชำระเงินต้น</vs-th>
            <vs-th>เงินต้นคงเหลือ</vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr v-for="item in data" :key="item.no">
              <vs-td>{{ item.no }}</vs-td>
              <vs-td>{{ item.date }}</vs-td>
              <vs-td>{{ item.days }}</vs-td>
              <vs-td>{{ item.paymentRoundAmount }}</vs-td>
              <vs-td>{{ item.paymentInterest }}</vs-td>
              <vs-td>{{ item.paymentPrincipal }}</vs-td>
              <vs-td>{{ item.principalRemain }}</vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vx-card>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import flatPickr from 'vue-flatpickr-component'
import {Thai} from 'flatpickr/dist/l10n/th'
import 'flatpickr/dist/themes/dark.css';
import moment from "moment/moment";
import pmt from 'formula-pmt';
import {mRound, numberFormat} from "@/utils";

export default {
  name: 'InstallmentCalculationCard',
  components: {
    vSelect,
    flatPickr
  },
  data() {
    return {
      configPaymentDue: {
        monthSelectorType: "static",
        allowInput: true,
        locale: Thai,
        dateFormat: "d-m-Y",
        disable: [
          (date) => {
            // ปิดวันทั้งหมดที่ไม่ใช่วันสุดท้ายของเดือน
            return moment(date).date() !== moment(date).endOf('month').date();
          }
        ]
      },
      restructuringFee: 0,
      restructuringPenalty: 0,
      restructuringInterest: 0,
      principle: 0, // default principle amount
      installmentCount: 0, // Default installment count
      interestRate: 12, // Default interest rate
      paymentDue: moment().endOf('month').format('DD-MM-YYYY'), // Default payment due date (end of current month)
      paymentRoundAmountPrincipal: 0,
      paymentRoundAmountRestructuring: 0,
      paymentRoundAmount: 0,
      paymentRoundAmountLast: 0,
      totalRemain: 0,
      firstPaymentDate: '',
      lastPaymentDate: '',
      paymentRounds: []
    };
  },
  computed: {
    totalRestructuring() {
      return {
        value: Number(this.restructuringFee) + Number(this.restructuringPenalty) + Number(this.restructuringInterest),
        readonly: true,
      };
    }
  },
  methods: {
    async calculate() {
      const vm = this;

      if (vm.installmentCount <= 0 || !vm.paymentDue) {
        vm.$vs.notify({
          title: 'ข้อผิดพลาด',
          text: 'กรุณากรอกจำนวนงวดและรอบชำระเดือนแรก',
          color: 'danger',
        });
        return;
      }

      vm.$vs.loading();
      vm.paymentRounds = [];

      const interestPerMonth = (Number(vm.interestRate) / 100) / 12;
      const totalPeriods = Number(vm.installmentCount);
      const principalAmount = Number(vm.principle);
      const restructuringAmount = vm.totalRestructuring.value;

      // ✅ คำนวณยอดผ่อนต่อเดือน (PMT)
      const paymentRoundAmountPrincipal = mRound(-pmt(interestPerMonth, totalPeriods, principalAmount), 10);
      const paymentRoundAmountRestructuring = mRound(restructuringAmount / totalPeriods, 10)
      let principalRemain = principalAmount;
      let restructuringRemain = restructuringAmount;
      let currentPaymentRoundDate = moment(vm.$options.filters.convDDMMYYYYToYYYYMMDD(vm.paymentDue.trim()));

      for (let i = 1; i <= totalPeriods; i++) {
        const currentPaymentRoundDateSom = moment(currentPaymentRoundDate).startOf('month');
        const nextPaymentRoundDate = moment(currentPaymentRoundDate).add(1, 'day').endOf('month');
        const daysInPeriod = currentPaymentRoundDate.diff(currentPaymentRoundDateSom, 'days') + 1; // +1 to include the start day

        if (i === 1) {
          vm.paymentRounds.push({
            no: "-",
            date: currentPaymentRoundDateSom.locale('th').format('DD MMM YY'),
            days: "-",
            paymentRoundAmount: "-",
            paymentInterest: "-",
            paymentPrincipal: "-",
            principalRemain: numberFormat(principalRemain),
            paymentRestructuring: "-",
            restructuringRemain: numberFormat(restructuringRemain),
          });
        }

        const paymentInterest = principalRemain * interestPerMonth;
        const paymentPrincipal = paymentRoundAmountPrincipal - paymentInterest;
        principalRemain = principalRemain - paymentPrincipal;
        const paymentRestructuring = paymentRoundAmountRestructuring;
        restructuringRemain = restructuringRemain - paymentRestructuring;

        vm.paymentRounds.push({
          no: i,
          date: currentPaymentRoundDate.locale('th').format('DD MMM YY'),
          days: daysInPeriod,
          paymentRoundAmount: numberFormat(paymentRoundAmountPrincipal),
          paymentInterest: numberFormat(paymentInterest),
          paymentPrincipal: numberFormat(paymentPrincipal),
          principalRemain: numberFormat(principalRemain),
          paymentRestructuring: numberFormat(paymentRestructuring),
          restructuringRemain: numberFormat(restructuringRemain),
        });

        currentPaymentRoundDate = nextPaymentRoundDate;
      }
      const paymentRoundAmount = paymentRoundAmountPrincipal + paymentRoundAmountRestructuring;
      const totalRemain = principalRemain + restructuringRemain;

      vm.paymentRoundAmountPrincipal = numberFormat(paymentRoundAmountPrincipal);
      vm.paymentRoundAmountRestructuring = numberFormat(paymentRoundAmountRestructuring);
      vm.paymentRoundAmount = numberFormat(paymentRoundAmount);
      vm.totalRemain = numberFormat(totalRemain);
      vm.paymentRoundAmountLast = numberFormat(totalRemain + paymentRoundAmount);
      vm.firstPaymentDate = vm.paymentRounds[1].date;
      vm.lastPaymentDate = vm.paymentRounds.at(-1).date;

      setTimeout(() => {
        vm.$vs.loading.close();
      }, 500);
    }
  },
  async created() {

  },
};
</script>

<style scoped>
</style>
